/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('ArticleDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		ArticleFactory,
		AlertService,
		NoPagingArticleFactory,
		NoPagingArticleTypeFactory,
		NoPagingVatTypeFactory,
		ArticleSaveAndCreateFactory
	) {
		$scope.article = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.article) && $rootScope.isDefinedAndNotNull($scope.article.id);
		};

		$scope.createArticleType = function() {
			var referredBy = {
				refName: 'articleType',
				data: $scope.article,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new articleType will add this new article state to the history stack
				$state.go('article.list.newArticleType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('article.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type ArticleType and checks if this Article dialog is called in the context of ArticleType.
		 * If this is the case, we detect the parent entity Article and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticleType = function() {
			return NoPagingArticleTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'articleType');
			});
		};
		$scope.articleTypeList = $scope.queryArticleType();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type VatType and checks if this Article dialog is called in the context of VatType.
		 * If this is the case, we detect the parent entity Article and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryVatType = function() {
			return NoPagingVatTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'vatType');
			});
		};
		$scope.vatTypeList = $scope.queryVatType();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:articleUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Article failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		var onSaveAndNewFinishedCallback = function(result) {
			$scope.$emit('emsApp:articleUpdate', result);
			// the result contains a new entity, but with the copied values from the previous
			$scope.article = result;
			$scope.updateDropdownModels();
			$scope.submitButtonIsActive = true;
		};

		$scope.updateDropdownModels = function() {
			$scope.queryArticleType();
			$scope.queryVatType();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.article.id != null) {
				ArticleFactory.update($scope.article, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				ArticleFactory.save($scope.article, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		$scope.saveAndNew = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.article.id != null) {
				ArticleSaveAndCreateFactory.updateAndCreate($scope.article, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				ArticleSaveAndCreateFactory.saveAndCreate($scope.article, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});
